import { Outlet, Link } from "react-router-dom";




export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  return (
    <footer id="colophon" className="site-footer footer-primary">
      <div className="top-footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <aside className="widget widget_text">
                <h3 className="widget-title">About Travel</h3>
                <div className="textwidget widget-text">
                  JourneyScape: Unveiling the cultural heritage, breathtaking
                  landscapes, and warm hospitality of Pakistan and neighboring
                  countries through unforgettable tourism experiences.
                </div>
                <div className="award-img">
                  <a href="tel:03084534190">
                    <img src="assets/images/logo6.png" alt="" />
                  </a>
                  <a href="tel:03084534190">
                    <img src="assets/images/logo2.png" alt="" />
                  </a>
                </div>
              </aside>
            </div>
            <div className="col-lg-3 col-md-6">
              <aside className="widget widget_text">
                <h3 className="widget-title">CONTACT INFORMATION</h3>
                <div className="textwidget widget-text">
                  <ul>
                    <li>
                      <a href="tel:923084534190">
                        <i className="fas fa-phone-alt" />
                        +92 (308) 4534190
                      </a>
                    </li>
                    <li>
                      <a href="mailto:sameerhassan888@gmail.com">
                        <i className="fas fa-envelope" />
                        sameerhassan888@gmail.com
                      </a>
                    </li>
                    <li>
                      <i className="fas fa-map-marker-alt" />
                      Lahore,Pakistan
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
            <div className="col-lg-3 col-md-6">
              <aside className="widget widget_recent_post">
                <h3 className="widget-title">Latest Post</h3>
                <ul>
                  <li>
                    <h5>
                      <a href="tel:03084534190">
                        Life is a beautiful journey not a destination
                      </a>
                    </h5>
                    <div className="entry-meta">
                      <span className="post-on">
                        <a href="tel:03084534190">August 17, 2023</a>
                      </span>
                      <span className="comments-link">
                        <a href="tel:03084534190">No Comments</a>
                      </span>
                    </div>
                  </li>
                  <li>
                    <h5>
                      <a href="tel:03084534190">Take only memories, leave only footprints</a>
                    </h5>
                    <div className="entry-meta">
                      <span className="post-on">
                        <a href="tel:03084534190">August 17, 2023</a>
                      </span>
                      <span className="comments-link">
                        <a href="tel:03084534190">No Comments</a>
                      </span>
                    </div>
                  </li>
                </ul>
              </aside>
            </div>
            <div className="col-lg-3 col-md-6">
              <aside className="widget widget_newslatter">
                <h3 className="widget-title">SUBSCRIBE US</h3>
                <div className="widget-text">
                  Subscribe to JourneyScape for exclusive travel updates,
                  promotions, and the latest tourism offerings.
                </div>
                <form className="newslatter-form">
                  <input type="email" name="s" placeholder="Your Email.." />
                  <input type="submit" name="s" defaultValue="SUBSCRIBE NOW" />
                </form>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="buttom-footer">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-5">
              <div className="footer-menu">
                <ul>
                  <li>
                    <Link to="/PrivacyPolicy" onClick={scrollToTop}>Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/TermsConditions" onClick={scrollToTop}>Term &amp; Condition</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="col-md-2 text-center"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div className="footer-logo">
                <a href="tel:03084534190">
                  <img
                    src="https://res.cloudinary.com/debltnmge/image/upload/v1684610968/JourneyScape1_kdfny7.webp"
                    alt=""
                  />
                </a>
              </div>
            </div>
            <div className="col-md-5">
              <div className="copy-right text-right">
                Copyright © 2023 JourneyScape. All rights reserved
              </div>
            </div>
          </div>
        </div>
      </div>
      <Outlet />
    </footer>
  );
}
